import React from "react";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";

import triviaLogo from "assets/images/sbs/triviaLogo.png";
import TriviaSubmit from "assets/images/sbs/TriviaSubmit.png";
import lightningTrivia from "assets/images/sbs/lightningTrivia.png";

const NotBestTime = ({
  bestTime,
  yourTime,
  mobile_app,
  yourAnswer,
  lts = false,
  over_params,
  top_logo_mobile
}) => {
  const divVariants = {
    hidden: {},
    visible: {},
    exit: {}
  };
  const buttonVariants = {
    hidden: { x: "100vw" },
    visible: { x: 0 },
    exit: { x: "-100vw" }
  };
  const textVariants = {
    hidden: { opacity: 0.4, scale: 0 },
    visible: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0 }
  };
  const imgExitVariants = {
    exit: {
      y: "-100vh",
      opacity: 0.5,
      scale: 0.7,
      transition: {
        type: "tween",
        duration: 0.5,
        opacity: { duration: 0.3 },
        scale: { duration: 0.3 },
        y: { delay: 0.3 }
      }
    }
  };

  const so_close = _.get(over_params, "so_close", "So close!");
  const your_time = _.get(over_params, "your_time", "Your Time:");
  const best_time = _.get(over_params, "best_time", "Best Time:");
  const answer_label = _.get(over_params, "answer_label", "Answer:");
  const got_it_right = _.get(over_params, "got_it_right", "You got it right!");

  return (
    <div
      className={`container NotBestTime res-screen ${
        mobile_app ? "mobile-cnt" : "web-cnt"
      } ${top_logo_mobile ? "global" : ""}`}
    >
      <motion.div
        variants={divVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className="Lightning-trivia-Wrapper"
      >
        <motion.img
          variants={imgExitVariants}
          src={
            lts
              ? TriviaSubmit
              : top_logo_mobile
              ? top_logo_mobile
              : lightningTrivia
          }
          className="logoimage"
          alt="sbsLogo"
        />
        <motion.h3 variants={buttonVariants} className="largeText whiteText">
          {got_it_right}
        </motion.h3>
        <motion.img
          variants={buttonVariants}
          src={triviaLogo}
          className="randomImage"
          alt="emoges"
        />
        <motion.h2 variants={textVariants} className="mediamText blueText">
          {answer_label}
        </motion.h2>
        <motion.button
          disabled
          variants={textVariants}
          className="sbsButton answerBtn"
        >
          {yourAnswer}
        </motion.button>
        <motion.p variants={textVariants} className="largeText whiteText">
          {so_close}
        </motion.p>
        <div className="timeWrapper mb52">
          <div className="text-center">
            <motion.h4 variants={textVariants} className="mediamText blueText">
              {your_time}
            </motion.h4>
            <motion.h2
              variants={textVariants}
              className="mediamText whiteText m-0"
            >
              {yourTime} Seconds
            </motion.h2>
          </div>
          <div className="text-center">
            <motion.h4
              variants={textVariants}
              className="mediamText yellowText"
            >
              {best_time}
            </motion.h4>
            <motion.h2
              variants={textVariants}
              className="mediamText whiteText m-0"
            >
              {bestTime} Seconds
            </motion.h2>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default NotBestTime;
